import React, { useState, useCallback } from 'react';
import { Typography, Box, Button, useMediaQuery, useTheme, Grid, FormControl } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectField } from '../../../../../Components/Field';
import { TypedFormFieldValue } from '../../../../../Components/Form/Form.types';
import { useStyles } from '../../../../../Components/Field/Field.styles';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import { StepButtonBar } from '../EditLegalListWizard/StepButtonBar';
import { StepProps } from './types';
import { INamedEntity } from '../../../../../Api/AptorApi';
import UpdateConnectionInfo from './UpdateConnectionInfo';

const PRIMARY = '#c4122f';

interface Step2SelectConnectionProps extends StepProps {
  connectionOptions: SelectOption[];
  selectedConnection?: INamedEntity;
  onConnectionSelect: (connection: SelectOption) => void;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}

const Step2SelectConnection = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  connectionOptions,
  selectedConnection,
  onConnectionSelect,
  currentStepName,
    updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step2SelectConnectionProps) => {
  const [localSelected, setLocalSelected] = useState<SelectOption | undefined>(
    selectedConnection ? { label: selectedConnection.name, value: selectedConnection.id } : undefined
  );
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);
  const classes = useStyles();

  const handleChange = useCallback((val: TypedFormFieldValue<number> | TypedFormFieldValue<number>[] | undefined) => {
    if (val && !Array.isArray(val)) {
      setLocalSelected(val as SelectOption);
    }
  }, []);

  const handleNext = () => {
    if (localSelected) {
      onConnectionSelect(localSelected);
      onNext();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '350px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <Grid container spacing={3} justifyContent="flex-start">
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Box style={{ maxWidth: '100%', width: '100%', minWidth: '320px' }}>
                  <FormControl className={classes.formControl} style={{ width: '100%' }}>
                    {/* <Typography className={classes.label} component="label">
                      {formatMessage({ id: 'law-portal.manage.update-laws.connection' })}
                    </Typography> */}
                    <SelectField
                      name="connection"
                      placeholder={formatMessage({
                        id: 'law-portal.manage.update-laws.connection.placeholder',
                      })}
                      options={connectionOptions}
                      isMulti={false}
                      errorTexts={[]}
                      initialState={localSelected}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
        <UpdateConnectionInfo
        updateConnectionInfo={updateConnectionInfo}
        currentStepName={currentStepName}
        onUpdate={setUpdateConnectionInfo}
      />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.next"
          nextDisabled={!localSelected}
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
      </Box>
    </div>
  );
};

export default Step2SelectConnection;
